import { PostActionTypeEnum } from "../../../types";
import { PostActionModel } from "../PostActionModel";

export default class UnpinChatMessageActionModel extends PostActionModel {
    type = PostActionTypeEnum.UnpinChatMessageAction;
}
